import React from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useGetInvoicesHandler } from '../../resources/Invoices/dataHandlers/getInvoicesHandler';
import useDocumentFilters from '../filters/DocumentFilterHelper';

const InvoiceSelect = ({ name, onSelect, document_type }) => {
  const { currentQuery, handleSearchChange, handleSearchKeyPress } = useDocumentFilters({
    defaultQuery: {
      document_type: document_type,
      status: new Set(['active', 'draft']),
    },
  });

  const { invoices, isLoading } = useGetInvoicesHandler({ searchQuery: currentQuery });

  return (
    <Autocomplete
      id={name}
      options={invoices}
      loading={isLoading}
      getOptionLabel={(option) =>
        `${option?.document_number} | ${option?.document_date} | ${option?.grand_total} | ${option?.billed_by?.name}`
      }
      getOptionKey={(option) => option?._id}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Invoice"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      onChange={(_, value) => onSelect(value)}
      onInputChange={(event, value, reason) => {
        if (reason === 'input') {
          handleSearchChange(event);
        }
      }}
      onKeyDown={handleSearchKeyPress}
      filterOptions={(x) => x}
    />
  );
};

export default InvoiceSelect;
